export enum ArticlesContentBlock {
  Root = 'ArticlesContent',
}

export enum ArticlesContentElement {
  Header = 'header',
  Title = 'title',
  Table = 'table',
}
